import * as actions from '../mfaTokensActions';
import TokenTextField from './TokenTextField';
import { Field } from '../types';
import { HYPR_MFA_TOKEN_FIELDS } from '../../../common/fields';
import React, { FC, useCallback } from 'react';
import TokenActions from './TokenActions';
import { TokenComponentProps } from './index';

type DispatchFn = (action: UpdateAction) => void;

interface UpdateAction {
    type: typeof actions.UPDATE_HYPR_MFA_TOKEN;
    payload: {
        fieldId: string;
        value: string;
    };
}

export interface HyprFields {
    hyprAppId: Field;
    hyprUrl: Field;
    hyprAccessToken: Field;
}

export type HyprProps = TokenComponentProps<HyprFields, DispatchFn>;

const Hypr: FC<HyprProps> = ({ fields, dispatch, onSave, onCancel }) => {
    const hyprAppId = fields[HYPR_MFA_TOKEN_FIELDS.HYPR_APP_ID.ID];
    const hyprUrl = fields[HYPR_MFA_TOKEN_FIELDS.HYPR_URL.ID];
    const hyprAccessToken = fields[HYPR_MFA_TOKEN_FIELDS.HYPR_ACCESS_TOKEN.ID];

    const isSomeFieldsEmpty = [hyprAppId, hyprUrl, hyprAccessToken].some((field) => !field.value);
    const textFields = [
        { field: hyprUrl, isSecret: false, placeholder: 'Enter URL' },
        { field: hyprAppId, isSecret: false, placeholder: 'Enter app id' },
        { field: hyprAccessToken, isSecret: true, placeholder: 'Enter token' }
    ];

    const dispatchUpdate = useCallback(
        (fieldId: string, value: string) => {
            dispatch({
                type: actions.UPDATE_HYPR_MFA_TOKEN,
                payload: { fieldId, value }
            });
        },
        [dispatch]
    );

    return (
        <>
            {textFields.map(({ field, isSecret, placeholder }) => (
                <TokenTextField
                    key={field.id}
                    label={field.name}
                    value={field.value}
                    isSecret={isSecret}
                    placeholder={placeholder}
                    onChange={(val) => dispatchUpdate(field.id, val)}
                />
            ))}
            <TokenActions onSave={onSave} onCancel={onCancel} saveDisabled={isSomeFieldsEmpty} />
        </>
    );
};

export default Hypr;
